import { render, staticRenderFns } from "./mobile-editor.vue?vue&type=template&id=6d1e81bc&scoped=true"
import script from "./mobile-editor.vue?vue&type=script&lang=js"
export * from "./mobile-editor.vue?vue&type=script&lang=js"
import style0 from "./mobile-editor.vue?vue&type=style&index=0&id=6d1e81bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1e81bc",
  null
  
)

export default component.exports